export const FLAG_GETTING_PRICING_PROFILES = 'FLAG_GETTING_PRICING_PROFILES';
export const GET_PRICING_PROFILES = 'GET_PRICING_PROFILES';
export const CLEAR_PRICING_PROFILES = 'CLEAR_PRICING_PROFILES';
export const FLAG_PRICING_PROFILE_ACTIVITY = 'FLAG_PRICING_PROFILE_ACTIVITY';
export const GET_PRICING_PROFILE = 'GET_PRICING_PROFILE';
export const CLEAR_PRICING_PROFILE = 'CLEAR_PRICING_PROFILE';
